import React from "react";
import { Card, Typography } from "antd";
import LoaderTsx from "../../../Loader.tsx";

const { Title, Text } = Typography;

interface BookingCardProps {
  title: string;
  value: string;
  extraText: string;
  style: {
    backgroundColor: string;
    color: string;
    border?: string;
  };
  isLoading?: boolean;
}

const BookingCard: React.FC<BookingCardProps> = React.memo(
  ({ title, value, extraText, style, isLoading }) => {
    return (
      <Card
        className="booking-card"
        style={{
          borderRadius: "12px",
          minHeight: "180px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          ...style,
        }}
      >
        {isLoading ? (
          <LoaderTsx height={"15vh"} />
        ) : (
          <>
            <Text
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: style.color,
              }}
            >
              {title}
            </Text>

            <Title level={3} style={{ margin: "8px 0", color: style.color }}>
              {value ? value : 0}
            </Title>

            <div style={{ display: "block", marginTop: "4px" }}>
              <Text
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  color: style.color,
                  opacity: 0.8,
                  display: "block",
                }}
              >
                Value
              </Text>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: style.color,
                }}
              >
                {extraText ? extraText : "AED 0"}
              </Text>
            </div>
          </>
        )}
      </Card>
    );
  }
);

export default BookingCard;
